"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldWrapper = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const FormFieldWrapper_styles_1 = require("./FormFieldWrapper.styles");
/**
 * @deprecated Use `Form.Field` instead
 */
const FormFieldWrapper = (_a) => {
    var { children, label, labelProps, subLabel, subLabelProps, successMessage, errors, warnings, metaInfo, grouped = false, as = "div" } = _a, props = __rest(_a, ["children", "label", "labelProps", "subLabel", "subLabelProps", "successMessage", "errors", "warnings", "metaInfo", "grouped", "as"]);
    const validErrors = errors === null || errors === void 0 ? void 0 : errors.filter(Boolean);
    const hasErrors = !!validErrors && validErrors.length > 0;
    const validWarnings = warnings === null || warnings === void 0 ? void 0 : warnings.filter(Boolean);
    const hasWarnings = !!validWarnings && validWarnings.length > 0;
    if (successMessage && (hasErrors || hasWarnings)) {
        console.warn("You should not have successMessage and errors or warnings at the same time");
    }
    const renderLabel = () => {
        if (as === "div") {
            return (react_1.default.createElement(__1.Text, { variant: "label", as: "label", props: labelProps }, label));
        }
        return (react_1.default.createElement(__1.Text, { variant: "label", as: "legend" }, labelProps ? (react_1.default.createElement(__1.Text, Object.assign({ skinny: true }, labelProps), label)) : (label)));
    };
    const renderSubLabel = () => {
        return typeof subLabel === "string" ? (react_1.default.createElement(__1.Text, { variant: "body", skinny: true, props: subLabelProps }, subLabel)) : (subLabel);
    };
    return (react_1.default.createElement(FormFieldWrapper_styles_1.StyledWrapper, Object.assign({ as: as }, props),
        label && renderLabel(),
        subLabel && renderSubLabel(),
        react_1.default.createElement(FormFieldWrapper_styles_1.StyledFormInputs, { grouped: grouped }, children),
        (hasErrors || hasWarnings || successMessage || metaInfo) && (react_1.default.createElement(FormFieldWrapper_styles_1.StyledFormFieldInformation, { "data-testid": "feedback-info" },
            react_1.default.createElement(FormFieldWrapper_styles_1.StyledFormFieldFeedbackInfo, null,
                successMessage && !hasErrors && !warnings && (react_1.default.createElement(__1.FormFieldFeedback, { variant: "success", text: successMessage })),
                hasErrors &&
                    (validErrors === null || validErrors === void 0 ? void 0 : validErrors.map((err, i) => err && (react_1.default.createElement(__1.FormFieldFeedback, { key: i, variant: "error", text: err })))),
                hasWarnings &&
                    (validWarnings === null || validWarnings === void 0 ? void 0 : validWarnings.map((err, i) => err && (react_1.default.createElement(__1.FormFieldFeedback, { key: i, variant: "warning", text: err }))))),
            metaInfo && (react_1.default.createElement(FormFieldWrapper_styles_1.StyledFormFieldMetaInfo, null,
                react_1.default.createElement(__1.Text, { variant: "note" }, metaInfo)))))));
};
exports.FormFieldWrapper = FormFieldWrapper;
//# sourceMappingURL=FormFieldWrapper.js.map